__turbopack_context__.v({
  "actionsCell": "UaAAAa_actionsCell",
  "changeOrdersHeader": "UaAAAa_changeOrdersHeader",
  "changeOrdersHeader__copy": "UaAAAa_changeOrdersHeader__copy",
  "changeOrdersHeader__subtitle": "UaAAAa_changeOrdersHeader__subtitle",
  "changeOrdersHeader__title": "UaAAAa_changeOrdersHeader__title",
  "changeOrdersSummary": "UaAAAa_changeOrdersSummary",
  "changeOrdersView": "UaAAAa_changeOrdersView",
  "impactNeutral": "UaAAAa_impactNeutral",
  "impactPositive": "UaAAAa_impactPositive",
  "tableWrap": "UaAAAa_tableWrap",
});
